<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color" style="background-color: #1e4374">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/logoSACTransparente.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4 flex">
                  <h4 class="mb-6">Acesso</h4>
                  <p class="ml-auto text-xs font-medium">v. {{VERSAO}} </p> 
                </div>

                <div>
                  <vs-input
                      name="login"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      label-placeholder="Login"
                      @keyup.enter="efetuarLogin()"
                      v-model="login"
                      class="w-full"/>

                  <vs-input
                      type="password"
                      name="senha"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      label-placeholder="Senha"
                      @keyup.enter="efetuarLogin()"
                      v-model="senha"
                      class="w-full mt-6" />
                  
                  <div class="flex flex-wrap justify-between my-5 items-center"></div>
                    <vs-button @click="efetuarLogin">ENTRAR</vs-button>
                    
                  </div>
                 
                
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    return {
      login: "",
      senha: "",      
      publicPath: process.env.BASE_URL,
    }
  },
  created(){
      this.VERSAO = process.env.VUE_APP_NUMERO_VERSAO
  },
  methods: {
      efetuarLogin() {      
        const params = new URLSearchParams();        
        params.append('cpf', this.login);
        params.append('senha', this.senha);
                
        this.$vs.loading();

        let currentObj = this;
        
        this.$http.post('/Usuario/ValidarUsuario', 
            params, { headers: {'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'}
        }).then(function (response) {
            currentObj.$vs.loading.close();
            
            if (response.data.Usuario.id && response.data.Usuario.id !== 0) {   
                localStorage.login = currentObj.login;
                currentObj.$store.commit("SALVAR_USUARIO_LOGADO", response.data.Usuario);   
                if ((currentObj.$store.state.AppActiveUser.perfil === 'GESTOR') || (currentObj.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') || (currentObj.$store.state.AppActiveUser.perfil === 'FINANCEIRO')) {
                  currentObj.$router.push({ path: '/home' })
                } else if (currentObj.$store.state.AppActiveUser.perfil === 'CRM_CONTA_RECEBER' || currentObj.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER') {
                  currentObj.$router.push({ path: '/financeiro/contas-a-receber/pesquisar' })
                } else if (currentObj.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_PAGAR') {
                  currentObj.$router.push({ path: '/financeiro/contas-a-pagar/pesquisar' })
                } else if (currentObj.$store.state.AppActiveUser.perfil === 'COMPRAS') {
                  currentObj.$router.push({ path: '/financeiro/compras/pesquisar' })
                } else if (currentObj.$store.state.AppActiveUser.perfil === 'CRM') {
                  currentObj.$router.push({ path: '/cadastro/favorecidos/pesquisar' })
                }
            } else {                	            
              currentObj.$vs.notify({ 
                title: "Erro", text: "Acesso Inválido",  iconPack: 'feather', icon: 'icon-alert-circle', color: 'danger'  });
            }
            
        }).catch(function () {
            currentObj.$vs.loading.close();
            
            currentObj.$vs.notify({
                    title: "Erro",
                    text: "Erro no acesso",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                  });
        });

      }
  }  
}
</script>
